// Funciones de manejo de sonidos del quiz
import buildSoundUrl from '../config/soundUrlHelper';

const createAudioElement = (path, settings = {}) => {
  const audio = new Audio(buildSoundUrl(path));

  if (settings.volume !== undefined) {
    audio.volume = settings.volume;
  }

  if (settings.loop) {
    audio.loop = true;
  }

  audio.preload = 'auto';
  audio.load();

  return audio;
};

const playWithRetry = async (audio, label) => {
  if (!audio) return;

  try {
    await audio.play();
  } catch (error) {
    console.warn(`Reintentando reproducir sonido ${label}:`, error);

    try {
      audio.load();
      await audio.play();
    } catch (retryError) {
      console.error(`Error al reproducir sonido ${label}:`, retryError);
    }
  }
};

// Función para inicializar sonidos
export const inicializarSonidos = (soundPaths, soundSettings) => {
  const sounds = {};
  
  for (const [key, path] of Object.entries(soundPaths)) {
    const settings = soundSettings[key] || {};
    sounds[key] = createAudioElement(path, settings);
  }
  
  return sounds;
};

// Función para hacer fade in del sonido de tensión
export const tensionSoundFadeIn = (soundRef) => {
  if (soundRef.current) {
    soundRef.current.volume = 0;
    soundRef.current.currentTime = 0;
    soundRef.current.loop = true;
    playWithRetry(soundRef.current, 'de tensión');
    
    // Gradualmente aumentar el volumen durante 2 segundos (2000ms)
    let volume = 0;
    const fadeInDuration = 2000; // 2 segundos
    const incrementTime = 50; // Incrementar cada 50ms
    const volumeIncrement = (0.3 / (fadeInDuration / incrementTime)); // Incremento proporcional para alcanzar 0.3 en 2 segundos
    
    const fadeInInterval = setInterval(() => {
      if (soundRef.current) {
        volume += volumeIncrement;
        soundRef.current.volume = Math.min(volume, 0.3); // Volumen máximo de 0.3
        if (volume >= 0.3) {
          clearInterval(fadeInInterval);
        }
      }
    }, incrementTime); // Incrementar volumen cada 50ms
  }
};

// Función para hacer fade out del sonido de tensión
export const tensionSoundFadeOut = (soundRef) => {
  if (soundRef.current) {
    let volume = soundRef.current.volume;
    const fadeOutDuration = 500; // 0.5 segundos
    const decrementTime = 50; // Disminuir cada 50ms
    const volumeDecrement = (volume / (fadeOutDuration / decrementTime)); // Decremento proporcional para reducir volumen a 0 en 0.5 segundos
    
    const fadeOutInterval = setInterval(() => {
      if (soundRef.current) {
        volume -= volumeDecrement;
        soundRef.current.volume = Math.max(volume, 0);
        if (volume <= 0) {
          clearInterval(fadeOutInterval);
          soundRef.current.pause();
          soundRef.current.currentTime = 0;
        }
      }
    }, decrementTime); // Disminuir volumen cada 50ms
 }
};

// Función para reproducir sonido de acierto
export const reproducirSonidoAcierto = (soundRef) => {
 if (soundRef.current) {
    playWithRetry(soundRef.current, 'de acierto');
  }
};

// Función para reproducir sonido de error
export const reproducirSonidoError = (soundRef) => {
  if (soundRef.current) {
    playWithRetry(soundRef.current, 'de error');
  }
};

// Función para inicializar los sonidos y manejar referencias
export const inicializarSonidosYReferencias = (soundPaths, soundSettings, aciertoSoundRef, errorSoundRef, tensionSoundRef) => {
  const sounds = inicializarSonidos(soundPaths, soundSettings);
  aciertoSoundRef.current = sounds.acierto;
  errorSoundRef.current = sounds.error;
  tensionSoundRef.current = sounds.tension;
};
